import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconLogoColab = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M5.06541 9.08411L2.88146 6.89087C1.67664 8.09827 1 9.7343 1 11.44C1 13.1457 1.67664 14.7817 2.88146 15.9891L5.0747 13.7959C4.44978 13.1717 4.09786 12.3252 4.09612 11.4419C4.09438 10.5587 4.44295 9.71076 5.06541 9.08411Z",
			fill: "#E8710A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.88146 6.89071L5.06541 9.08395C5.37527 8.77373 5.74324 8.52763 6.14827 8.35972C6.55331 8.1918 6.98747 8.10538 7.42594 8.10538C7.8644 8.10538 8.29856 8.1918 8.7036 8.35972C9.10864 8.52763 9.4766 8.77373 9.78646 9.08395L11.3756 6.36098L11.2827 6.28663C10.0431 5.36184 8.51219 4.91398 6.96964 5.02489C5.42709 5.13581 3.97596 5.79809 2.88146 6.89071Z",
			fill: "#F9AB00"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.3849 16.5187L9.78646 13.8051C9.4766 14.1153 9.10864 14.3614 8.7036 14.5293C8.29856 14.6972 7.8644 14.7836 7.42594 14.7836C6.98747 14.7836 6.55331 14.6972 6.14827 14.5293C5.74324 14.3614 5.37527 14.1153 5.06541 13.8051L2.88146 15.9983C3.97378 17.0812 5.41759 17.7374 6.95171 17.8482C8.48582 17.959 10.0089 17.517 11.2455 16.6024L11.3478 16.5187",
			fill: "#F9AB00"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.9983 6.89075C10.7935 8.09815 10.1168 9.73418 10.1168 11.4399C10.1168 13.1456 10.7935 14.7816 11.9983 15.989L14.1915 13.7958C13.5655 13.1697 13.2138 12.3206 13.2138 11.4352C13.2138 10.5499 13.5655 9.70075 14.1915 9.0747C14.8176 8.44865 15.6667 8.09694 16.5521 8.09694C17.4374 8.09694 18.2865 8.44865 18.9126 9.0747L21.1151 6.89075C20.5169 6.29138 19.8064 5.81588 19.0242 5.49144C18.242 5.167 17.4035 5 16.5567 5C15.7099 5 14.8714 5.167 14.0892 5.49144C13.307 5.81588 12.5965 6.29138 11.9983 6.89075Z",
			fill: "#F9AB00"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.1151 6.89087L18.9312 9.08411C19.5572 9.71016 19.9089 10.5593 19.9089 11.4446C19.9089 12.33 19.5572 13.1791 18.9312 13.8052C18.3051 14.4312 17.456 14.7829 16.5706 14.7829C15.6853 14.7829 14.8362 14.4312 14.2101 13.8052L11.9983 15.9984C13.206 17.2074 14.8446 17.8871 16.5534 17.8879C17.3996 17.8884 18.2375 17.7221 19.0194 17.3987C19.8013 17.0753 20.5119 16.6011 21.1105 16.0031C21.7091 15.405 22.1841 14.695 22.5083 13.9134C22.8325 13.1318 22.9996 12.2941 23 11.4479C23.0004 10.6018 22.8342 9.76384 22.5108 8.98194C22.1874 8.20003 21.7131 7.48949 21.1151 6.89087Z",
			fill: "#E8710A"
		})
	]
});
export { SvgIconLogoColab as ReactComponent };
